import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PagePaper } from '../../components/PagePaper';
import PageTitle from '../../components/PageTitle';
import Wizard from '../../components/Wizard';
import { OrientacoesModal } from '../Processo/components/OrientacoesModal';
import { ProcessEdicaoProvider, useProcessEdicaoContext, } from './context/ProcessEdicaoContext';
import { ConfirmacaoForm } from './forms/ConfirmacaoForm';
import { FuncionariosForm } from './forms/FuncionariosForm';
import { OperadoresForm } from './forms/OperadoresForm';
import { VeiculosForm } from './forms/VeiculosForm';
var ProcessoEdicaoPage = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var navigate = useNavigate();
    var _c = useParams(), stepKey = _c.stepKey, id = _c.id;
    var servico = useProcessEdicaoContext().servico;
    var currentStep = stepKey || 'funcionarios';
    var handleStepChange = function (newStepKey) {
        var modo = disabled ? 'visualizar' : 'editar';
        navigate("/processo-edicao/".concat(modo, "/").concat(newStepKey, "/").concat(id));
    };
    return (_jsxs(PagePaper, { children: [_jsx(PageTitle, { children: "Processo de Credenciamento" }), _jsx(OrientacoesModal, { servico: servico }), _jsxs(Wizard, { currentStep: currentStep, onStepChange: handleStepChange, children: [_jsx(Wizard.Step, { title: "Dados dos Funcion\u00E1rios", stepKey: "funcionarios", children: _jsx(FuncionariosForm, { disabled: disabled }) }), _jsx(Wizard.Step, { title: "Operadores da Empresa", stepKey: "operadores-empresa", visible: !!(servico === null || servico === void 0 ? void 0 : servico.exigeOperador), children: _jsx(OperadoresForm, { disabled: disabled }) }), _jsx(Wizard.Step, { title: "Ve\u00EDculos da Empresa", stepKey: "veiculos", visible: !!(servico === null || servico === void 0 ? void 0 : servico.incluirVeiculos), children: _jsx(VeiculosForm, { disabled: disabled }) }), _jsx(Wizard.Step, { title: "Confirma\u00E7\u00E3o dos Dados", stepKey: "confirmacao", children: _jsx(ConfirmacaoForm, { disabled: disabled }) })] })] }));
};
export default (function (_a) {
    var disabled = _a.disabled;
    return (_jsx(ProcessEdicaoProvider, { children: _jsx(ProcessoEdicaoPage, { disabled: disabled }) }));
});
